initTimify = function initTimify() {
    const timifyElements = document.querySelectorAll('[data-account-id]');
    if (window.TimifyWidget && timifyElements.length) {
        window.TimifyWidget.init();
    }
}